export default {
	id: 'SIMPLE_WORKBOOK_BUNDLE_3WB_29_99',
	providers: {
		paltaMap: {
			USD: 'simple_workbook_bundle_3wb_29_99_usd',
		},
		primer: 'prd_HSGFp8f5SW5Q',
	},
	otp: {
		priceMap: {
			USD: 29.99,
		},
	},
}
